import { MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { formatAddress } from '../../../../../../../Dispatch/utils/utils';
import appConstants from '@appConstants';

const getShipmentsGridConfig = () => ({
  title: 'Shipments',
  columns: [
    {
      headerName: 'Seq',
      field: 'stopSequence',
      headerTooltip: 'Stop Sequence',
      pinned: "left",
      minWidth: appConstants.columnWidth.W_60,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Route',
      field: 'routeName',
      headerTooltip: 'Route Name',
      pinned: "left",
      minWidth: appConstants.columnWidth.W_120,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Pro#',
      field: 'proId',
      headerTooltip: 'PRO Number',
      pinned: "left",
      minWidth: appConstants.columnWidth.PROID,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Customer',
      field: 'customerName',
      headerTooltip: 'Customer Name',
      minWidth: appConstants.columnWidth.CUSTOMER,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Address',
      field: 'address',
      valueGetter: (params: any) => formatAddress({
        address: params.data.address,
        address2: params.data.address2
      }) ?? '',
      headerTooltip: 'Address',
      tooltipValueGetter: (params: any) => params.value,
      minWidth: appConstants.columnWidth.W_200,
      filter: MultiSelectFilter,
      filterParams: {
        width: appConstants.columnWidth.W_200
      }
    },
    {
      headerName: 'City',
      field: 'city',
      headerTooltip: 'City',
      minWidth: appConstants.columnWidth.W_120,
      filter: MultiSelectFilter
    },
    {
      headerName: 'State',
      field: 'state',
      headerTooltip: 'State',
      minWidth: appConstants.columnWidth.REGION,
      filter: MultiSelectFilter
    },
    {
      headerName: 'Zip',
      field: 'zip',
      headerTooltip: 'Zip Code',
      minWidth: appConstants.columnWidth.ZIP_CODE,
      filter: MultiSelectFilter
    }
  ]
});

export default getShipmentsGridConfig;
